module.exports = __webpack_public_path__ + "static/media/Oncology-Periodic Check In-2@3x.bc192fe0.png";